import { keyframes } from '@emotion/react';
import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const spinAnimation = keyframes`
0% {
  transform: rotate(0deg) scale(1);
}
50% {
  transform: rotate(180deg) scale(1.4);
}
100% {
  transform: rotate(360deg) scale(1);
}
`;
export default {
  loaderArea: (fullCover?: boolean, isLoading?: boolean, isTransparent?: boolean) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    bg: fullCover ? isTransparent ? 'rgba(55, 55, 55, 0.65)' : theme.rawColors.neutralWhite : theme.rawColors.lightGreyBg,
    opacity: isLoading ? 1 : 0,
    visibility: isLoading ? 'visible' : 'hidden',
    ...reusables.mainTransition('opacity', 'visibility'),
    zIndex: theme.zIndex.megaMenu
  }),
  loader: (isFixed?: boolean) => ({
    position: isFixed ? 'fixed' : 'absolute',
    width: '80px',
    height: '80px',
    zIndex: theme.zIndex.megaMenu,
    top: '50%',
    left: '50%',
    transform: 'translate(-25%, -25%)',
    svg: {
      position: 'relative',
      zIndex: theme.zIndex.megaMenu,
      animation: `${spinAnimation} 1.5s linear infinite`,
      '& path:nth-of-type(1)': {
        fill: theme.rawColors.neutralWhite,
        stroke: 'transparent'
      },
      fill: theme.rawColors.neutralBlack,
      stroke: 'transparent'
    }
  })
};